import React,{useEffect,useState} from 'react'
import {Box,Typography} from '@mui/material';
import css from '../css/sidebarlink.module.css';
import {Link} from 'react-router-dom';
import overview2 from '../images/overview-2.png';
import overview1 from '../images/overview-1.png';
import {GrSettingsOption as Settings1,GrUserSettings as Settings2} from 'react-icons/gr';
import {FcInvite as InductionIcon} from  'react-icons/fc';
import {MdApproval as ApplicationIcon1} from  'react-icons/md';
import { useLocation } from 'react-router-dom';
import { act } from 'react-dom/test-utils';
import {MdOutlinePortrait as ApplicantIcon1} from 'react-icons/md';
import {MdPortrait as ApplicationIcon2} from 'react-icons/md';
import {AiTwotoneMail as TrainingIcon, AiOutlineMail as TrainingIcon2} from 'react-icons/ai';
import {MdApproval as ApprovalIcon2} from 'react-icons/md';
import {MdOutlinePayment as PaymentIcon} from 'react-icons/md';
import { RiQuestionAnswerFill as InterviewIcon1,RiQuestionAnswerLine as InterviewIcon2 } from "react-icons/ri";
import OverviewIcon from '../svg/overview.svg';
import {AiOutlineHome as Home1,AiTwotoneHome as Home2}  from 'react-icons/ai';
import { TbMessageReport as ReportIcon } from "react-icons/tb";
import { useSelector } from 'react-redux';
import { store } from '../redux/store';
import { Settings } from '@mui/icons-material';
import { GrCloudUpload } from "react-icons/gr";
import {GrCloudUpload as UploadIcon} from 'react-icons/gr';




const linkList = [ 
    {icon1: <Home1 />, icon2: <Home2/>, path:"/dashboard/overview", name:"Overview"},
    {icon1: <Settings1/>, icon2: <Settings2/>, path:"/dashboard/settings", name:"Settings"},
    {icon1: ApplicantIcon1, icon2: ApplicantIcon1, path:"/dashboard/applicants", name:"Applicants"},
    {icon1: <ApplicationIcon2/>, icon2: <ApplicationIcon2/>, path:"/dashboard/old-applicants", name:"Old-Applicants"},
    {icon1: <ApplicantIcon1/>, icon2: <ApplicantIcon1/>, path:"/dashboard/applications", name:"Applications"},
    {icon1: <ApprovalIcon2/>, icon2: <ApprovalIcon2/>, path:"/dashboard/approvals", name:"Approvals"},
    {icon1: PaymentIcon, icon2: PaymentIcon, path:"/dashboard/payment", name:"Payment"},
    // {icon1: UploadIcon, icon: UploadIcon, path:"/dashboard/upload-off-line-payment", name:"Upload-OffLine-Payment"},
    {icon1: <InterviewIcon1/>, icon2: <InterviewIcon2/>, path:"/dashboard/interview", name:"Interview"},
    {icon1: <TrainingIcon/>, icon2: TrainingIcon2, path:"/dashboard/training-invites", name:"Training-Invites"},
    {icon1: <InductionIcon/>, icon2: InductionIcon, path:"/dashboard/induction-invites", name:"Induction-Invites"},
    {icon1: <ReportIcon/>, icon2: ReportIcon, path:"/dashboard/reports", name:"Reports"}, 
 
];

const SideBarLinks = () => { 
    const user = useSelector((store:any) => store.user);

  return (
    <Box component={"div"} className={css.container}>
        <em> Welcome..{user?.FirstName?.length >10?`${user?.FirstName?.slice(0,10)+'...'}`:user?.FirstName}</em>
        <Typography component={"div"} style={{ marginBlock: '4px'}}>
            {linkList.map((eLink,index) => 
                <EachLink key={index} eLink={eLink} index={index}/>)
            }
        </Typography>
    </Box>
  )
}

export default SideBarLinks;

const EachLink =  (props:any) =>{
    const eLink = props.eLink;
    const index = props.index;
    const [activeIcon, setActiveIcon] = useState(eLink.icon1);
    const [activeClass, setActiveClass] = useState('');
    const location = useLocation();
    const user = useSelector((store:any) => store.user);

    useEffect(() => {
  const activePath = location.pathname;
  let lastString = activePath.split('/').at(-1);

  if (eLink.path && activePath === eLink.path) {
    setActiveIcon(eLink.icon2);
    setActiveClass(css.activeLink);
  }
  // handle special case for Applicants/Old-Applicants
  else if (
    activePath.includes("old-applicants") &&
    eLink.name.toLowerCase() === "applicants"
  ) {
    setActiveClass('');
    setActiveIcon(eLink.icon1);
  }
  else {
    setActiveIcon(eLink.icon1);
    setActiveClass('');
  }
}, [location.pathname, eLink.path]);

    return(
        <>
            <AuthorizeView role={user.role} name={eLink.name} link={
                <Link to={eLink.path} className={activeClass} >
                    <span>
                        {/* <img style={{width:'15px'}} src={activeIcon} alt={eLink.name} /> */}
                        {typeof activeIcon === 'string' ?'icon':activeIcon}
                    </span>
                    <span style={{fontSize: '14px'}}>{eLink.name}</span>
                </Link>
            } />
            
        </>
    )
}

export const AuthorizeView = (props:any) =>{
    const role:string = props.role;
    const name:string = props.name.toLowerCase();
    const link = props.link;
    let allow_roles = ['Director of membership','Administrator',  'Team Lead'];
    let show:any = true;
    let checkName = () => name.includes('settings');
    
    if(checkName()){
        show = allow_roles.find(eRole => eRole.toLowerCase().includes(role.toLowerCase()))
    }

    return show?link:<></>;

}